/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface AccountCreditAdjustment
 */
export interface AccountCreditAdjustment {
    /**
     * 
     * @type {string}
     * @memberof AccountCreditAdjustment
     */
    accountId: string;
    /**
     * 
     * @type {number}
     * @memberof AccountCreditAdjustment
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof AccountCreditAdjustment
     */
    description: string;
}

export function AccountCreditAdjustmentFromJSON(json: any): AccountCreditAdjustment {
    return {
        'accountId': json['accountId'],
        'amount': json['amount'],
        'description': json['description'],
    };
}

export function AccountCreditAdjustmentToJSON(value?: AccountCreditAdjustment): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'accountId': value.accountId,
        'amount': value.amount,
        'description': value.description,
    };
}


